import React from 'react';
import Countdown from './Countdown';

const CTA = () => {
  return (
    <section className="cta-section py-16 md:py-24 relative overflow-hidden bg-gradient-to-br from-blue-900 via-blue-800 to-purple-900" id="contact">
      <div className="absolute inset-0 bg-[url('https://images.unsplash.com/photo-1579546929662-711aa81148cf?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1740&q=80')] bg-cover bg-center opacity-10"></div>
      
      {/* Animated elements */}
      <div className="absolute top-0 left-0 w-full h-full opacity-5">
        <div className="absolute top-20 left-10 w-72 h-72 bg-blue-500 rounded-full filter blur-3xl animate-pulse-slow"></div>
        <div className="absolute bottom-10 right-10 w-96 h-96 bg-purple-500 rounded-full filter blur-3xl animate-pulse-slow" style={{animationDelay: '1.5s'}}></div>
      </div>
      
      <div className="container mx-auto px-4 relative z-10">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-4xl md:text-5xl font-bold mb-6 text-white">Ready to Transform Your Financial Future?</h2>
          <p className="text-xl text-blue-100 mb-10">Join thousands of members who are already earning with VumaQash. Your journey to financial freedom starts today!</p>
          
          {/* Countdown Timer */}
          <div className="bg-white/10 backdrop-blur-sm p-6 rounded-2xl border border-white/20 mb-10">
            <p className="text-yellow-200 text-lg mb-3 font-semibold">⏰ Registration closes soon:</p>
            <Countdown />
          </div>
          
          {/* Action Buttons */}
          <div className="flex flex-col sm:flex-row gap-5 justify-center items-center mb-8">
            <a href="https://wa.me/254115647545?text=Hey%20Cleophas,%20I'm%20interested%20in%20VumaQash%20Agencies"
              className="inline-flex items-center justify-center bg-gradient-to-r from-yellow-400 to-yellow-500 hover:from-yellow-500 hover:to-yellow-600 text-black font-bold px-8 py-5 rounded-full shadow-2xl transition-all transform hover:scale-105 duration-300 text-lg w-full sm:w-auto">
              <i className="fab fa-whatsapp text-2xl mr-3"></i> START EARNING NOW
            </a>
            
            <a href="https://www.vumaqash.com/user/register.php?ref=CLEOPHAS"
              className="inline-flex items-center justify-center bg-gradient-to-r from-blue-500 to-blue-600 hover:from-blue-600 hover:to-blue-700 text-white font-bold px-8 py-5 rounded-full shadow-2xl transition-all transform hover:scale-105 duration-300 text-lg w-full sm:w-auto">
              <i className="fas fa-user-plus mr-3"></i> REGISTER NOW
            </a>
          </div>
          
          {/* Trust Indicators */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mt-12">
            <div className="flex items-center justify-center text-white">
              <div className="bg-white/10 p-3 rounded-full mr-3">
                <i className="fas fa-users text-yellow-400"></i>
              </div>
              <div>
                <p className="font-bold text-lg">4,832+</p>
                <p className="text-sm text-blue-200">Active Members</p>
              </div>
            </div>
            
            <div className="flex items-center justify-center text-white">
              <div className="bg-white/10 p-3 rounded-full mr-3">
                <i className="fas fa-globe-africa text-yellow-400"></i>
              </div>
              <div>
                <p className="font-bold text-lg">12+</p>
                <p className="text-sm text-blue-200">Countries</p>
              </div>
            </div>
            
            <div className="flex items-center justify-center text-white">
              <div className="bg-white/10 p-3 rounded-full mr-3">
                <i className="fas fa-money-bill-wave text-yellow-400"></i>
              </div>
              <div>
                <p className="font-bold text-lg">$373/day</p>
                <p className="text-sm text-blue-200">Potential Earnings</p>
              </div>
            </div>
          </div>
          
          <p className="text-sm text-yellow-200 mt-8 flex items-center justify-center">
            <i className="fas fa-exclamation-circle mr-2"></i> Limited spots available - Join before registration closes!
          </p>

          {/* Additional CTA */}
          <div className="mt-16 bg-white/10 backdrop-blur-sm p-8 rounded-2xl border border-white/20">
            <h3 className="text-2xl font-bold mb-4 text-white">Still Have Questions?</h3>
            <p className="text-blue-100 mb-6">Our team is ready to answer all your questions and guide you through the registration process.</p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <a href="https://wa.me/254115647545?text=I%20have%20questions%20about%20VumaQash" 
                 className="inline-flex items-center bg-green-500 hover:bg-green-600 text-white font-bold py-3 px-6 rounded-lg transition-colors">
                <i className="fab fa-whatsapp mr-2"></i> Chat on WhatsApp
              </a>
              <a href="https://chat.whatsapp.com/KBmtWKO6vEC9XLGdDpUTmJ" 
                 className="inline-flex items-center bg-blue-500 hover:bg-blue-600 text-white font-bold py-3 px-6 rounded-lg transition-colors">
                <i className="fas fa-users mr-2"></i> Join Community
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTA;